import { writeSettingsFields } from './settings-fields';

/** `PATCH /client/settings/fields {route_optimisation: {ro_start_end_locations}}`. */
export const editROStartEndLocations = async (ro_start_end_locations: any): Promise<any> =>
  writeSettingsFields({
    route_optimisation: {
      ro_start_end_locations:
        ro_start_end_locations?.ro_start_end_locations ?? ro_start_end_locations
    }
  });
